<script>
import Switcher from "@/components/switcher";
import { HomeIcon, MailIcon } from "vue-feather-icons";
import { Radio, FormModel, Input, Button, Row, Col, } from 'ant-design-vue'
import { changePasswordApi, getCodeApi, } from '@/api'
import i18n from '@/i18n'
import Navbar from "@/components/navbar";

/**
 * Auth-re-password component
 */
export default {
  data() {
    return {
      formData: {
        email: '',
        passwordNew: '',
        code: '',
      },
      countdown: 60,
      isCounting: false,
      timer: null,
      codeLoading: false,
      rules: {
        email: [
          { required: true, message: i18n.t('请输入邮箱地址'), trigger: 'blur' },
          { type: 'email', message: i18n.t('请输入正确的邮箱地址'), trigger: ['blur', 'change'] }
        ],
        passwordNew: [
          { required: true, message: i18n.t('请输入密码'), trigger: 'blur' },
          { min: 6, max: 20, message: i18n.t('密码长度在 6 到 20 个字符'), trigger: 'blur'},
        ],
        code: [
          { required: true, message: i18n.t('请输入邮箱验证码'), trigger: 'blur' },
        ]
      },
      loading: false
    };
  },
  methods: {
    async sendVerificationCode () {
      if (!this.formData.email) return
      if (this.isCounting) return;

      this.codeLoading = true

      getCodeApi({
        type: 2,
        email: this.formData.email
      }).then(() => {
        // 开始倒计时
        this.isCounting = true;
        this.timer && clearInterval(this.timer)
        this.timer = setInterval(() => {
          if (this.countdown <= 0) {
            clearInterval(this.timer);
            this.isCounting = false;
            this.countdown = 60; // 重置倒计时为60秒
          } else {
            this.countdown--;
          }
        }, 1000);
        this.$message.success(this.$t('验证码已发送'));  // 提示信息
      }).catch(err => {
        this.$message.error(err.msg || err);  // 提示信息
      }).finally(() => {
        this.codeLoading = false
      })
    },
    onSubmit () {
      this.$refs.form.validate().then(() => {
        this.loading = true

        changePasswordApi(this.formData).then((res) => {
          this.$message.success(this.$t('密码修改成功'))
          this.$router.push('/auth-login')
        }).catch(err => {
          this.$message.error(err.msg || err)
        }).finally(() => {
          this.loading = false
        })
      })
    },
    resetForm () {
      this.$refs.form.clearValidate()
    }
  },
  components: {
    Switcher,
    MailIcon,
    HomeIcon,
    Navbar,
    'a-radio-button': Radio.Button,
    'a-radio-group': Radio.Group,
    'a-form': FormModel,
    'a-form-item': FormModel.Item,
    'a-input': Input,
    'a-input-password': Input.Password,
    'a-button': Button,
    'a-row': Row,
    'a-col': Col,
  },
};
</script>

<template>
  <div>
    <Navbar isWhiteNavbar></Navbar>

    <!-- Hero Start -->
    <section class="bg-home d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-7 mx-auto">
            <div class="card shadow rounded border-0">
              <img src="@/assets/images/auth-bg-min.png" alt="bg">

              <div class="card-body">
                <h4 class="card-title text-center">{{ $t('重置密码') }}</h4>

                <a-form
                  :model="formData"
                  :rules="rules"
                  ref="form"
                  :layout="'vertical'"
                  class="login-form mt-4"
                  @submit.prevent="onSubmit"
                >
                  <!-- 用户名 -->
                  <a-form-item :label="$t('用户名')" prop="email">
                    <a-input
                      v-model="formData.email"
                      size="large"
                      :placeholder="$t('请输入邮箱地址')"
                     >
                      <i slot="prefix" class="uil uil-user"></i>
                     </a-input>
                  </a-form-item>

                  <!-- 密码 -->
                  <a-form-item :label="$t('新密码')" prop="passwordNew">
                    <a-input-password
                      v-model="formData.passwordNew"
                      size="large"
                      type="password"
                      :placeholder="$t('请输入新密码')"
                    >
                      <i slot="prefix" class="uil uil-key-skeleton"></i>
                    </a-input-password>
                  </a-form-item>

                  <!-- 验证码 -->
                  <a-form-item :label="$t('邮箱验证码')" prop="code">
                    <a-row type="flex">
                      <a-col flex="2" class="code-input">
                        <a-input
                          v-model="formData.code"
                          size="large"
                          :placeholder="$t('请输入邮箱验证码')"
                        >
                          <i slot="prefix" class="uil uil-lock-alt"></i>
                        </a-input>
                      </a-col>
                      <a-col flex="1" class="pl-2 get-code">
                        <a-button
                          :disabled="isCounting || !formData.email"
                          :loading="codeLoading"
                          block
                          @click="sendVerificationCode"
                          size="large"
                        >
                          {{ isCounting ? `${countdown}s` : $t('获取验证码') }}
                        </a-button>
                      </a-col>
                    </a-row>
                  </a-form-item>

                  <!-- 登录按钮 -->
                  <a-form-item class="mb-0">
                    <a-button :loading="loading" size="large" type="primary" html-type="submit" block>
                      {{ $t('确定') }}
                    </a-button>
                  </a-form-item>
                  <div class="col-12 text-center">
                    <p class="mb-0">
                      <router-link to="/auth-login" class="font-weight-bold">{{ $t('去登录') }}</router-link>
                    </p>
                  </div>
                </a-form>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->
    <Switcher />
  </div>
</template>

<style lang="scss">
.bg-home {

  .card {
    display: flex;
    flex-direction: row;
    border-radius: 24px!important;
    box-shadow: 0px 4px 50px 0px #2F55D429;
    img {
      width: 315px;
    }

    .card-body {
      flex: 1;
    }

    .ant-radio-button-wrapper {
      border: none!important;
      box-shadow: none!important;
      color: #575574!important;
      font-size: 16px!important;
      border-radius: 0px!important;
      padding-left: 0px!important;
      padding-right: 0px!important;
      margin-right: 24px!important;

      &::before {
        display: none!important;
      }

      &.ant-radio-button-wrapper-checked {
        border-bottom: 2px solid #2F55D4!important;

        & > span {
          color: #1A1B21!important;
          font-size: 24px!important;
          font-weight: 700!important;
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    .card {
      img {
        display: none;
      }
      .code-input {
        flex: 1!important;
        input {
          width: 100%!important;
        }
      }
      .get-code, .get-code button {
        width: 120px!important;
        flex: unset!important;
      }
    }
  }
}
</style>
